import { Navigate, useParams } from 'react-router-dom'
import useResident from 'hooks/useResident'
import ProfessionalContactForm from '../forms/ProfessionalContactForm'

const ProfessionalContactCreateScreen = ({ testId }: { testId?: string } = {}) => {
  const { id } = useParams()

  if (!id) {
    return <Navigate to="/residents" />
  }
  const { isLoading, resident, updateResident } = useResident({ id })

  return (
    <div data-testid={testId ? `${testId}-professional-contact-create-screen` : 'professional-contact-create-screen'}>
      <ProfessionalContactForm
        editedIndex={undefined}
        onSubmit={updateResident}
        isLoading={isLoading}
        resident={resident}
        testId={testId}
      />
    </div>
  )
}

export default ProfessionalContactCreateScreen
